module.exports = __webpack_public_path__ + "img/m-plan-1-BG.b733f792.png";